/* eslint-disable */
import * as Types from '../../../clients/graphqlTypes.js';

import { gql } from '@apollo/client';
import { PhotoApprovalProcessFragmentDoc } from './PhotoApprovalProcess.generated.js';
import { AddTaskWorkSessionsProcess_ItemFragmentDoc } from '../work-sessions/AddTaskWorkSessionsProcess.generated.js';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type TaskManagementButtons_AllDocItemFragment = { __typename: 'Item', id: string, canBeWorkedOn: boolean, photoApprovalRequired: boolean, deletedAt?: any | null, timeTrackingRequired: boolean, docId: string, title: string, type: Types.ItemType, isDone: boolean, rank: number, level: number, parentId?: string | null, isRootItem: boolean, pathForPdf: string, pathSortable: string, isHidden: boolean, isPriceHidden: boolean, isParentDecisionPreselected: boolean, isParentDecisionNotPreselected: boolean, isParentContingencyNotPreselected: boolean, binding: Types.ItemBinding, decisionIsContingentItem: boolean, decisionSubitemsPreselection: Array<string>, decisionBehaviorOfSubitems: Types.DecisionBehaviorOfSubitems, decisionContingentItemPreselection?: boolean | null, isExplicitHidden: boolean, childrenVisibility: Types.ItemChildrenVisibility, isItemEliminated: boolean, hasChildren: boolean, qaApprovalRequired: boolean, approvalRequired: boolean, workSessionsDuration: number, dueDate?: any | null, doneDate?: any | null, priority: number, isVisibleToOtherSide: boolean, isQaApproved?: boolean | null, isApproved?: boolean | null, photoApproved?: { __typename: 'AttachmentSnapshot', id: string } | null, decisionOptionElimination?: { __typename: 'DecisionOptionElimination', reason: string } | null, assignee?: { __typename: 'User', id: string, firstname: string, familyname: string } | null, proposedCalculation?: { __typename: 'ItemCalculation', materialBuyingPricePerUnit: number, discountRate: number, materialMargin: number, materialPriceDiscountedSubTotal: number, materialPricePerUnit: number, materialPriceSubTotal: number, materialFactor: number, priceNetTotal: number, pricePerUnit: number, priceSubTotal: number, priceTotal: number, priceVatTotal: number, quantity: number, quantityUnit: Types.QuantityUnit, timePerUnit: number, timeTotal: number, workSellingRate: number, workBuyingRate: number, workRate: number, workBuyingPricePerUnit: number, workPriceDiscountedSubTotal: number, workPricePerUnit: number, workPriceSubTotal: number, workFactor: number, vatRate: number } | null };

export type TaskManagementButtonsQueryVariables = Types.Exact<{
  projectId: Types.Scalars['ID']['input'];
  docId: Types.Scalars['ID']['input'];
  itemId: Types.Scalars['ID']['input'];
}>;


export type TaskManagementButtonsQuery = { project: { __typename: 'MissingPermissions' } | { __typename: 'ProjectResult', project?: { __typename: 'Project', id: string, tasks: Array<{ __typename: 'TaskDocument', id: string, viewerPermissions: Array<Types.PermissionName>, items: Array<{ __typename: 'Item', id: string, originVersionNumber?: number | null, deletedAt?: any | null, type: Types.ItemType, agreement: Types.Agreement, isDone: boolean, photoApprovalRequired: boolean, qaApprovalRequired: boolean, isQaApproved?: boolean | null, approvalRequired: boolean, isApproved?: boolean | null, canBeWorkedOn: boolean, photoApproved?: { __typename: 'AttachmentSnapshot', id: string } | null }> }> } | null }, organisationDefaults: { __typename: 'OrganisationDefaults', id: string, defaultTaskPhotoIsRequired: boolean } };

export const TaskManagementButtons_AllDocItemFragmentDoc = gql`
    fragment TaskManagementButtons_AllDocItem on Item {
  id
  ...PhotoApprovalProcess
  ...AddTaskWorkSessionsProcess_Item
}
    ${PhotoApprovalProcessFragmentDoc}
${AddTaskWorkSessionsProcess_ItemFragmentDoc}`;
export const TaskManagementButtonsDocument = gql`
    query TaskManagementButtons($projectId: ID!, $docId: ID!, $itemId: ID!) {
  project(id: $projectId) {
    ... on ProjectResult {
      project {
        id
        tasks(id: $docId) {
          id
          viewerPermissions
          items(itemId: $itemId) {
            id
            originVersionNumber
            deletedAt
            type
            agreement
            isDone
            photoApprovalRequired
            photoApproved {
              id
            }
            qaApprovalRequired
            isQaApproved
            approvalRequired
            isApproved
            canBeWorkedOn
          }
        }
      }
    }
  }
  organisationDefaults {
    ... on OrganisationDefaults {
      id
      defaultTaskPhotoIsRequired
    }
  }
}
    `;

/**
 * __useTaskManagementButtonsQuery__
 *
 * To run a query within a React component, call `useTaskManagementButtonsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTaskManagementButtonsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTaskManagementButtonsQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      docId: // value for 'docId'
 *      itemId: // value for 'itemId'
 *   },
 * });
 */
export function useTaskManagementButtonsQuery(baseOptions: Apollo.QueryHookOptions<TaskManagementButtonsQuery, TaskManagementButtonsQueryVariables> & ({ variables: TaskManagementButtonsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TaskManagementButtonsQuery, TaskManagementButtonsQueryVariables>(TaskManagementButtonsDocument, options);
      }
export function useTaskManagementButtonsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TaskManagementButtonsQuery, TaskManagementButtonsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TaskManagementButtonsQuery, TaskManagementButtonsQueryVariables>(TaskManagementButtonsDocument, options);
        }
export function useTaskManagementButtonsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TaskManagementButtonsQuery, TaskManagementButtonsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TaskManagementButtonsQuery, TaskManagementButtonsQueryVariables>(TaskManagementButtonsDocument, options);
        }
export type TaskManagementButtonsQueryHookResult = ReturnType<typeof useTaskManagementButtonsQuery>;
export type TaskManagementButtonsLazyQueryHookResult = ReturnType<typeof useTaskManagementButtonsLazyQuery>;
export type TaskManagementButtonsSuspenseQueryHookResult = ReturnType<typeof useTaskManagementButtonsSuspenseQuery>;
export type TaskManagementButtonsQueryResult = Apollo.QueryResult<TaskManagementButtonsQuery, TaskManagementButtonsQueryVariables>;